//  ID: 271 TO 300

const ShoeList =
{
    MenApiCategory: "MensFootwear",
    MenShoeData: [
        {
            id: 271,
            brand: "Saucy Belle ",
            name: "High Top Synthetic Leather Sneakers For Men",
            main_img:
                "https://i.postimg.cc/DwShqqz0/1-1.jpg",
            item_img_1:
                "https://i.postimg.cc/8kbTDp3p/1-2.jpg",
            item_img_2:
                "https://i.postimg.cc/T3B6Qpy9/1-3.jpg",
            item_img_3:
                "https://i.postimg.cc/wTTgBK8h/1-4.jpg",
            item_img_4:
                "https://i.postimg.cc/HxgCDR98/1-5.jpg",
            color: "White",
            price: 568,
            old_price: "₹2499",
            price_off: "77% Off",
            category: "Shoe",
            rating: 3.9,
            
        },
        {
            id: 272,
            brand: "Woakers ",
            name: "Green Casual Shoes For Men High Tops For Men ",
            main_img:
                "https://i.postimg.cc/0j9xmF61/2-3.jpg",
            item_img_1:
                "https://i.postimg.cc/QtGjNHht/2-1.jpg",
            item_img_2:
                "https://i.postimg.cc/fLcDVDRv/2-2.jpg",
            item_img_3:
                "https://i.postimg.cc/d3nF96dk/2-4.jpg",
            item_img_4:
                "https://i.postimg.cc/zfW1Q8K1/2-5.jpg",
            color: "Green",
            price: 849,
            old_price: "₹3299",
            price_off: "74% Off",
            category: "Shoe",
            rating: 3.4,
            
        },
        {
            id: 273,
            brand: "OZJI",
            name: "Causal ankle boot Basketball Shoes For Men ",
            main_img:
                "https://i.postimg.cc/brYcdnMz/3-4.jpg",
            item_img_1:
                "https://i.postimg.cc/YqnkGXMT/3-1.jpg",
            item_img_2:
                "https://i.postimg.cc/Y9zBpRdn/3-2.jpg",
            item_img_3:
                "https://i.postimg.cc/RhPrtF5w/3-3.jpg",
            item_img_4:
                "https://i.postimg.cc/9FMHhGZb/3-5.jpg",
            color: "Blue",
            price: 599,
            old_price: "₹1699",
            price_off: "64% Off",
            category: "Shoe",
            rating: 3.8,
            
        },
        {
            id: 274,
            brand: "pollachief",
            name: "Casual Boots For Men Sneakers For Men",
            main_img:
                "https://i.postimg.cc/TY4MYpc6/4-2.jpg",
            item_img_1:
                "https://i.postimg.cc/zDpY6db3/4-1.jpg",
            item_img_2:
                "https://i.postimg.cc/6p4s7tHG/4-3.jpg",
            item_img_3:
                "https://i.postimg.cc/kg00KzZY/4-4.jpg",
            item_img_4:
                "https://i.postimg.cc/mr70wVWL/4-5.jpg",
            color: "Red",
            price: 558,
            old_price: "₹999",
            price_off: "44% Off",
            category: "Shoe",
            rating: 3.8,
            

        },
        {
            id: 275,
            brand: "ATOM",
            name: "Alpha Predator Sneakers For Men ",
            main_img:
                "https://i.postimg.cc/ydB2r97F/5-1.jpg",
            item_img_1:
                "https://i.postimg.cc/FKX67cd2/5-3.jpg",
            item_img_2:
                "https://i.postimg.cc/prL4PHhr/5-4.jpg",
            item_img_3:
                "https://i.postimg.cc/8kZxtj96/5-5.jpg",
            item_img_4:
                "https://i.postimg.cc/Px40Gxq0/5-2.jpg",
            color: "Blue",
            price: 1339,
            old_price: "₹3495",
            price_off: "61% Off",
            category: "Shoe",
            rating: 4.2,
            
        },
        {
            id: 276,
            brand: "ATOM",
            name: "Multi Print Funky Sneakers For Men ",
            main_img:
                "https://i.postimg.cc/1X7TtjwH/6-1.jpg",
            item_img_1:
                "https://i.postimg.cc/TYhFSTvH/6-2.jpg",
            item_img_2:
                "https://i.postimg.cc/HsKR1FpW/6-3.jpg",
            item_img_3:
                "https://i.postimg.cc/0yw3kZQY/6-4.jpg",
            item_img_4:
                "https://i.postimg.cc/s2PNSX51/6-5.jpg",
            color: "Black",
            price: 1299,
            old_price: "₹2495",
            price_off: "47% Off",
            category: "Shoe",
            rating: 4.3,
            
        },

        {
            id: 277,
            brand: "Bucik",
            name: "Lightweight Comfort Trendy Stylish Sneakers For Men ",
            main_img:
                "https://i.postimg.cc/kGG1kvzt/7-2.jpg",
            item_img_1:
                "https://i.postimg.cc/sXV0JrJm/7-1.jpg",
            item_img_2:
                "https://i.postimg.cc/JnPY626L/7-3.jpg",
            item_img_3:
                "https://i.postimg.cc/2ytcmBN9/7-4.jpg",
            item_img_4:
                "https://i.postimg.cc/PfVF10vb/7-5.jpg",
            color: "White",
            price: 674,
            old_price: "₹3299",
            price_off: "79% Off",
            category: "Shoe",
            rating: 3.9,
            
        },
        {
            id: 278,
            brand: "K’Footlance",
            name: "Comfortable Running Shoes For Men ",
            main_img:
                "https://i.postimg.cc/90DbxFwd/8-5.jpg ",
            item_img_1:
                "https://i.postimg.cc/431Wy0T9/8-4.jpg",
            item_img_2:
                "https://i.postimg.cc/7L4Bxkj4/8-2.jpg",
            item_img_3:
                "https://i.postimg.cc/HxsBytpP/8-3.jpg",
            item_img_4:
                "https://i.postimg.cc/t4WSQTSD/8-1.jpg",
            color: "Red",
            price: 488,
            old_price: "₹999",
            price_off: "51% Off",
            category: "Shoe",
            rating: 3.7,
            
        },
        {
            id: 279,
            brand: "asian",
            name: "Airweave-02 Grey Gym,Stylish Running Shoes For Men ",
            main_img:
                "https://i.postimg.cc/X7THzF8p/9-1.jpg",
            item_img_1:
                "https://i.postimg.cc/xCxgyb8j/9-2.jpg",
            item_img_2:
                "https://i.postimg.cc/8CTb2brP/9-3.jpg",
            item_img_3:
                "https://i.postimg.cc/vTCzCF5p/9-4.jpg",
            item_img_4:
                "https://i.postimg.cc/VLb4nv81/9-5.jpg",
            color: "Grey, Black",
            price: 1387,
            old_price: "₹2899",
            price_off: "51% Off",
            category: "Shoe",
            rating: 4.2,
            
        },
        {
            id: 280,
            brand: "ADIDAS",
            name: "RUNSTEER M Running Shoes For Men ",
            main_img:
                "https://i.postimg.cc/ZqjL4yrP/10-5.jpg",
            item_img_1:
                "https://i.postimg.cc/Nj64CnFz/10-4.jpg",
            item_img_2:
                "https://i.postimg.cc/MZLdnRgd/10-1.jpg",
            item_img_3:
                "https://i.postimg.cc/VkQgRwft/10-2.jpg",
            item_img_4:
                "https://i.postimg.cc/j5545dXp/10-3.jpg",
            color: "Green",
            price: 2067,
            old_price: "₹3999",
            price_off: "48% Off",
            category: "Shoe",
            rating: 4.2,
            
        },
    ],

    WomenApiCategory: "WomensFootwear",
    WomenShoeData: [
        {
            id: 286,
            brand: "Ketch",
            name: " WES Casuals by Westside White Shirt",
            main_img:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854606_437Wx649H_202303151508201.jpeg",
            item_img_1:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854606_437Wx649H_202303151508222.jpeg",
            item_img_2:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854606_437Wx649H_202303151508343.jpeg",
            item_img_3:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854606_437Wx649H_202303151508364.jpeg",
            item_img_4:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854606_437Wx649H_202303151508325.jpeg",
            price: 1299,
            old_price: "",
            Stock: "Limited Stock!!",
            price_off: "80% Off",
            category: "Shoe",
            rating: 2.9,
            
        },
        {
            id: 287,
            brand: "Villah",
            name: " Leather Retail Black Faux Leather Jacket",
            main_img:
                "https://i.postimg.cc/PqPzhsWw/42-9869571-mast-harbour-original-imafkwmb36bcyyzq.jpg",
            item_img_1:
                "https://i.postimg.cc/VvcjjJ3q/42-9869571-mast-harbour-original-imafkwmbmsudkqgc.jpg",
            item_img_2:
                "https://i.postimg.cc/yNth8Qjr/42-9869571-mast-harbour-original-imafkwmbzfza7edq.jpg",
            item_img_3:
                "https://i.postimg.cc/13WcL5qS/42-9869571-mast-harbour-original-imafkwmczngnuvtq.jpg",
            item_img_4:
                "https://i.postimg.cc/W3ZGFGfp/44-9869571-mast-harbour-original-imafkwmb6wwg5h2j.jpg",
            price: 499,
            old_price: "₹899",
            price_off: "48% Off",
            category: "Shoe",
            rating: 2.9,
            
        },

        {
            id: 288,
            brand: "U TURN",
            name: "Men Slim Fit Printed Cut Away Collar Casual Shirt",
            main_img:
                "https://i.postimg.cc/5ytZqLnZ/4.jpg",
            item_img_1:
                "https://i.postimg.cc/mDjvH8NY/5.jpg",
            item_img_2:
                "https://i.postimg.cc/FFWtFCKm/2.jpg",
            item_img_3:
                "https://i.postimg.cc/T1HBk1sh/3.jpg",
            item_img_4:
                "https://i.postimg.cc/ZRJkn13Y/1.jpg",
            price: 559,
            old_price: "₹1399",
            price_off: "60% Off",
            category: "Shoe",
            rating: 3.9,
            
        },
        {
            id: 289,
            brand: "Ketch",
            name: " White Cotton Slim Fit Printed Shirt",
            main_img:
                "https://img.tatacliq.com/images/i8/437Wx649H/MP000000013801964_437Wx649H_202207160616231.jpeg",
            item_img_1:
                "https://img.tatacliq.com/images/i8/437Wx649H/MP000000013801964_437Wx649H_202207160616252.jpeg",
            item_img_2:
                "https://img.tatacliq.com/images/i8/437Wx649H/MP000000013801964_437Wx649H_202207160616263.jpeg",
            item_img_3:
                "https://img.tatacliq.com/images/i8/437Wx649H/MP000000013801964_437Wx649H_202207160616284.jpeg",
            item_img_4:
                "https://img.tatacliq.com/images/i8/437Wx649H/MP000000013801964_437Wx649H_202207160616295.jpeg",
            price: 679,
            old_price: "₹3399",
            price_off: "80% Off",
            category: "Shoe",
            rating: 2.9,
            
        },
        {
            id: 290,
            brand: "Ketch",
            name: " Benetton Blue Linen Slim Fit Shirt",
            main_img:
                "https://img.tatacliq.com/images/i11/437Wx649H/MP000000017999211_437Wx649H_202306171934201.jpeg",
            item_img_1:
                "https://img.tatacliq.com/images/i11/437Wx649H/MP000000017999211_437Wx649H_202306171934172.jpeg",
            item_img_2:
                "https://img.tatacliq.com/images/i11/437Wx649H/MP000000017999211_437Wx649H_202306171934183.jpeg",
            item_img_3:
                "https://img.tatacliq.com/images/i11/437Wx649H/MP000000017999211_437Wx649H_202306171934224.jpeg",
            item_img_4:
                "https://img.tatacliq.com/images/i11/437Wx649H/MP000000017999211_437Wx649H_202306171934235.jpeg",
            price: 1859,
            old_price: "₹2999",
            price_off: "38% Off",
            category: "Shoe",
            rating: 2.9,
            
        },
        {
            id: 291,
            brand: "Ketch",
            name: "Arrow Rust Cotton Slim Fit Checks Shirt",
            main_img:
                "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016521121_437Wx649H_202302141654551.jpeg",
            item_img_1:
                "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016521121_437Wx649H_202302141654492.jpeg",
            item_img_2:
                "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016521121_437Wx649H_202302141654523.jpeg",
            item_img_3:
                "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016521121_437Wx649H_202302141654504.jpeg",
            item_img_4:
                "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016521121_437Wx649H_202302141654575.jpeg",
            price: 1428,
            old_price: "₹2599",
            price_off: "45% Off",
            category: "Shoe",
            rating: 2.9,
            
        },
        {
            id: 292,
            brand: "Ketch",
            name: "Allen Solly White Linen Slim Fit Shirt",
            main_img:
                "https://img.tatacliq.com/images/i12/437Wx649H/MP000000018435761_437Wx649H_202307231752221.jpeg",
            item_img_1:
                "https://img.tatacliq.com/images/i12/437Wx649H/MP000000018435761_437Wx649H_202307231752232.jpeg",
            item_img_2:
                "https://img.tatacliq.com/images/i12/437Wx649H/MP000000018435761_437Wx649H_202307231752243.jpeg",
            item_img_3:
                "https://img.tatacliq.com/images/i12/437Wx649H/MP000000018435761_437Wx649H_202307231752254.jpeg",
            item_img_4:
                "https://img.tatacliq.com/images/i12/437Wx649H/MP000000018435761_437Wx649H_202307231752215.jpeg",
            price: 3044,
            old_price: "₹3499",
            price_off: "13% Off",
            category: "Shoe",
            rating: 2.9,
            
        },
        {
            id: 293,
            brand: "Roaster",
            name: "Men Regular Fit Checks Casual Shirt",
            main_img:
                "https://i.postimg.cc/9Xv003Gh/42-11049786-here-now-original-imafzz4hbgvakn29.jpg",
            item_img_1:
                "https://i.postimg.cc/9Q2fPG8g/42-11049786-here-now-original-imafzz4hr6nuzmug.jpg",
            item_img_2:
                "https://i.postimg.cc/6TskXf2k/42-11049786-here-now-original-imafzz4htth6cuwa.jpg",
            item_img_3:
                "https://i.postimg.cc/3JmRDLBD/42-11049786-here-now-original-imafzz4hw5hmwtte.jpg",
            item_img_4:
                "https://i.postimg.cc/667TB64c/46-11049786-here-now-original-imafzz4hehzkc5zk.jpg",
            price: 1599,
            old_price: "₹800",
            price_off: "49% Off",
            category: "Shoe",
            rating: 2.9,
            
        },
        {
            id: 294,
            brand: "Ketch",
            name: "Being Human Black Slim Fit Shirt",
            main_img:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016907311_437Wx649H_202303181804201.jpeg",
            item_img_1:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016907311_437Wx649H_202303181804132.jpeg",
            item_img_2:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016907311_437Wx649H_202303181804103.jpeg",
            item_img_3:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016907311_437Wx649H_202303181804084.jpeg",
            item_img_4:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016907311_437Wx649H_202303181804165.jpeg",
            price: 895,
            old_price: "₹2799",
            price_off: "68% Off",
            category: "Shoe",
            rating: 2.9,
            
        },
        {
            id: 295,
            brand: "Ketch",
            name: " Multicolor Slim Fit Striped Cotton Shirt",
            main_img:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000017193988_437Wx649H_202304132040141.jpeg",
            item_img_1:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000017193988_437Wx649H_202304132040122.jpeg",
            item_img_2:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000017193988_437Wx649H_202304132040153.jpeg",
            item_img_3:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000017193988_437Wx649H_202304132040174.jpeg",
            item_img_4:
                "https://img.tatacliq.com/images/i10/437Wx649H/MP000000017193988_437Wx649H_202304132040115.jpeg",
            price: 1996,
            old_price: "₹2495",
            price_off: "20% Off",
            category: "Shoe",
            rating: 2.9,
            
        },
        // {
        //     id: 81,
        //     brand: "Ketch",
        //     name: "Maroon Cotton Regular Fit Checks Shirt",
        //     main_img:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019971943_437Wx649H_202311072351031.jpeg",
        //     item_img_1:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019971943_437Wx649H_202311072351052.jpeg",
        //     item_img_2:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019971943_437Wx649H_202311072351063.jpeg",
        //     item_img_3:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019971943_437Wx649H_202311072351014.jpeg",
        //     item_img_4:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019971943_437Wx649H_202311072351085.jpeg",
        //     price: 3199,
        //     Stock: "Limited Stock!",
        //     price_off: "60% Off",
        //     category: "Shoe",
        //     rating: 2.9,
        // 
        // },
        // {
        //     id: 82,
        //     brand: "Ketch",
        //     name: " Blue Cotton Regular Fit Shirt",
        //     main_img:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019972189_437Wx649H_202311080001091.jpeg",
        //     item_img_1:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019972189_437Wx649H_202311080001102.jpeg",
        //     item_img_2:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019972189_437Wx649H_202311080001123.jpeg",
        //     item_img_3:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019972189_437Wx649H_202311080001074.jpeg",
        //     item_img_4:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019972189_437Wx649H_202311080001135.jpeg",
        //     price: 2999,
        //     Stock: "Limited Stock!",
        //     price_off: "80% Off",
        //     category: "Shoe",
        //     rating: 2.9,
        // 
        // },
        // {
        //     id: 83,
        //     brand: "HIGHLANDER",
        //     name: "MEen Slim Fit Printed Cut Away Collar Casual Shirt",
        //     main_img:
        //         "https://i.postimg.cc/gJZSH4WX/1.jpg",
        //     item_img_1:
        //         "https://i.postimg.cc/DwxMv86Z/2.jpg",
        //     item_img_2:
        //         "https://i.postimg.cc/J0CT6JrT/3.jpg",
        //     item_img_3:
        //         "https://i.postimg.cc/FKqCS82X/4.jpg",
        //     item_img_4:
        //         "https://i.postimg.cc/cJ65r0kc/5.jpg",
        //     price: 636,
        //     old_price: "₹1749",
        //     price_off: "63% Off",
        //     category: "Shoe",
        //     rating: 4,
        //
        //  },
        // {
        //     id: 84,
        //     brand: "Ketch",
        //     name: " SHOWOFF Navy Blue Slim Fit Checks Shirt",
        //     main_img:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019827161_437Wx649H_202310271648411.jpeg",
        //     item_img_1:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019827161_437Wx649H_202310271648392.jpeg",
        //     item_img_2:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019827161_437Wx649H_202310271648423.jpeg",
        //     item_img_3:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019827161_437Wx649H_202310271648454.jpeg",
        //     item_img_4:
        //         "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019827161_437Wx649H_202310271648385.jpeg",
        //     price: 952,
        //     old_price: "₹2380",
        //     price_off: "60% Off",
        //     category: "Shoe",
        //     rating: 2.9,
        // 
        // },
        // {
        //     id: 85,
        //     brand: "Ketch",
        //     name: "Dark Green Regular Fit Shirt",
        //     main_img:
        //         "https://img.tatacliq.com/images/i8/437Wx649H/MP000000015191655_437Wx649H_202211060047171.jpeg",
        //     item_img_1:
        //         "https://img.tatacliq.com/images/i8/437Wx649H/MP000000015191655_437Wx649H_202211060047122.jpeg",
        //     item_img_2:
        //         "https://img.tatacliq.com/images/i8/437Wx649H/MP000000015191655_437Wx649H_202211060047093.jpeg",
        //     item_img_3:
        //         "https://img.tatacliq.com/images/i8/437Wx649H/MP000000015191655_437Wx649H_202211060047144.jpeg",
        //     item_img_4:
        //         "https://img.tatacliq.com/images/i8/437Wx649H/MP000000015191655_437Wx649H_202211060047195.jpeg",
        //     price: 1839,
        //     old_price: "₹2299",
        //     price_off: "20% Off",
        //     category: "Shoe",
        //     rating: 2.9,
        // 
        // },
        // {
        //     id: 86,
        //     brand: "Ketch",
        //     name: "Levi's Blue Relaxed Fit Floral Print Shirt",
        //     main_img:
        //         "https://img.tatacliq.com/images/i13/437Wx649H/MP000000019345428_437Wx649H_202309221412141.jpeg",
        //     item_img_1:
        //         "https://img.tatacliq.com/images/i13/437Wx649H/MP000000019345428_437Wx649H_202309221412112.jpeg",
        //     item_img_2:
        //         "https://img.tatacliq.com/images/i13/437Wx649H/MP000000019345428_437Wx649H_202309221412133.jpeg",
        //     item_img_3:
        //         "https://img.tatacliq.com/images/i13/437Wx649H/MP000000019345428_437Wx649H_202309221412164.jpeg",
        //     item_img_4:
        //         "https://img.tatacliq.com/images/i13/437Wx649H/MP000000019345428_437Wx649H_202309221412155.jpeg",
        //     price: 2319,
        //     old_price: "₹2899",
        //     price_off: "20% Off",
        //     category: "Shoe",
        //     rating: 2.9,
        // 
        // },
        // {
        //     id: 87,
        //     brand: "EIGHTEEN UP",
        //     name: "Men Slim Fit Stripped Spread Collar Casual Shirt",
        //     main_img:
        //         "https://i.postimg.cc/qMzqMJtQ/44-11896312-roadster-original-imafvx8mj4s7nqdh.jpg",
        //     item_img_1:
        //         "https://i.postimg.cc/QMtW22LW/s-sh-line-lblue-u-turn-original-imagharfhheynzyr.jpg",
        //     item_img_2:
        //         "https://i.postimg.cc/TP4WftGN/s-sh-line-lblue-u-turn-original-imagharfm4hfsezj.jpg",
        //     item_img_3:
        //         "https://i.postimg.cc/sg3WcBwm/s-sh-line-lblue-u-turn-original-imagharfy3dsh5yf.jpg",
        //     item_img_4:
        //         "https://i.postimg.cc/B6PP62nS/s-sh-line-lblue-u-turn-original-imagharfzyazgt3r.jpg",
        //     price: 1899,
        //     old_price: "₹459",
        //     price_off: "77% Off",
        //     category: "Shoe",
        //     rating: 2.9,
        // F
        // },
        // {
        //     id: 88,
        //     brand: "Ketch",
        //     name: "Pepe Jeans KINGSMAN Aqua Regular Fit Linen Shirt",
        //     main_img:
        //         "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016551529_437Wx649H_202302161544161.jpeg",
        //     item_img_1:
        //         "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016551529_437Wx649H_202302161543532.jpeg",
        //     item_img_2:
        //         "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016551529_437Wx649H_202302161543503.jpeg",
        //     item_img_3:
        //         "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016551529_437Wx649H_202302161543564.jpeg",
        //     item_img_4:
        //         "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016551529_437Wx649H_202302161544125.jpeg",
        //     price: 679,
        //     old_price: "₹3399",
        //     price_off: "80% Off",
        //     category: "Shoe",
        //     rating: 2.9,
        // 
        // },
        // {
        //     id: 89,
        //     brand: "ROADSTER",
        //     name: "T-shirtMen Regular Fit Printed Mandarin Collar Casual Shirt",
        //     main_img:
        //         "https://i.postimg.cc/bwTk458c/m-21988162-roadster-original-imagxftu4nrdywqg.jpg",
        //     item_img_1:
        //         "https://i.postimg.cc/hGZxt7f2/m-21988162-roadster-original-imagxftuacqgf4cy.jpg",
        //     item_img_2:
        //         "https://i.postimg.cc/B6dKx95D/m-21988162-roadster-original-imagxftuah9ghtda.jpg",
        //     item_img_3:
        //         "https://i.postimg.cc/PxLDprDT/m-21988162-roadster-original-imagxftudbqjtgwc.jpg",
        //     item_img_4:
        //         "https://i.postimg.cc/g028pKkw/m-21988162-roadster-original-imagxftuyw8s7zeg.jpg",
        //     price: 800,
        //     old_price: "₹1599",
        //     price_off: "49% Off",
        //     category: "Shoe",
        //     rating: 3.9,
        // 
        // },
        // {
        //     id: 90,
        //     brand: "HIGHLANDER",
        //     name: "Men Slim Fit Printed Cut Away Collar Casual Shirt",
        //     main_img:
        //         "https://i.postimg.cc/2SJH3RQn/5.jpg",
        //     item_img_1:
        //         "https://i.postimg.cc/15m7jKRV/1.jpg",
        //     item_img_2:
        //         "https://i.postimg.cc/hGd2dys6/2.jpg",
        //     item_img_3:
        //         "https://i.postimg.cc/Jzt614k1/3.jpg",
        //     item_img_4:
        //         "https://i.postimg.cc/X7s1SyXH/4.jpg",
        //     price: 558,
        //     old_price: "₹1299",
        //     price_off: "57% Off",
        //     category: "Shoe",
        // },
    ]
}

export default ShoeList;